
const usTerritories = ['GU', 'PR', 'VI'];

/**
 * This function determines if a country is part of the US and returns US if so
 * @param {string} country
 */
export default function normalizeCountry(country) {
    return usTerritories.indexOf(country) === -1 ? country : 'US';
}



// WEBPACK FOOTER //
// ./app/lib/format/normalizeCountry.js